import { render, staticRenderFns } from "./vaccinationIndividual.vue?vue&type=template&id=13b5dde6&scoped=true&"
import script from "./vaccinationIndividual.vue?vue&type=script&lang=js&"
export * from "./vaccinationIndividual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b5dde6",
  null
  
)

export default component.exports